import { h } from 'preact';
import {useLocationPicker} from "./useLocationPicker";
import s from "./locationPicker.module.css";
import {
    iconArrowSelect,
    iconSearch
} from "../../../../assets/";
import {useAppContext} from '../../../../contexts';

const LocationPicker = () => {
    // Component logic data
    const componentProps = useLocationPicker();

    // Destructured component logic data
    const {
        isOpen,
        currentLocation,
        availableLocations,
        contentRef,
        handleOpen,
        handleFilter,
        handleLocationChange,
        filterQuery
    } = componentProps;

    // Accessibility feature data
    const {accessibilityFont} = useAppContext();

    return (
        <div ref={contentRef} className={`h-full flex items-center relative select-none ${(isOpen ? "z-[20]" : "z-0")}`}>
            <button
                id="locationPickerDropdownButton"
                className={`z-20 text-white px-4 flex items-center justify-between gap-x-2 ${s.storePickerPill}`}
                style={{fontSize: `${14+accessibilityFont}px`}}
                type="button"
                onClick={() => handleOpen()}
                data-testid="location-picker-button"
            >
                <div className={"flex flex-row items-start"}>
                    <p className={"hidden md:block"}>
                        Você está em&nbsp;
                    </p>
                    <p>
                        {currentLocation}
                    </p>
                </div>
                <img
                    src={iconArrowSelect}
                    alt={"Store picker icon"}
                />
            </button>
            <div
                className={`absolute top-[47px] z-10 w-full left-0 rounded-b-2xl overflow-hidden dark:bg-gray-700 pt-3 ${s.storeSelectorContainer} ${(!isOpen ? "hidden" : "")}`}
                data-testid="location-picker-dropdown"
            >
                <ul 
                    className={`py-2 text-gray-700 dark:text-gray-200`} 
                    aria-labelledby="locationPickerDropdownButton"
                    style={{fontSize: `${14+accessibilityFont}px`}}
                >
                    <li className={"w-full"}>
                        <form className={"px-4 mb-2"}>
                            <div className="relative border-b border-b-gray-400">
                                <div className="absolute inset-y-0 left-0 flex items-center  pointer-events-none">
                                    <img
                                        src={iconSearch}
                                        alt={"Search icon"}
                                    />
                                </div>
                                <input
                                    type="search"
                                    id="search"
                                    className={`block w-full py-3 pl-8 text-white border-0 bg-transparent focus:ring-0 focus:border-0 placeholder-gray-300`}
                                    style={{fontSize: `${14+accessibilityFont}px`}}
                                    placeholder="Digite sua cidade"
                                    onInput={e => handleFilter(e)}
                                    value={filterQuery}
                                    data-testid="location-picker-input"
                                />
                            </div>
                        </form>
                    </li>
                    <li className={"w-full"}>
                        <ul className={"w-full h-full max-h-[400px] overflow-y-scroll discrete-scrollbar"}>
                            {availableLocations.length > 0 && availableLocations.map(item => {
                                return (
                                    <li key={item.id}>
                                        <button
                                            type={"button"}
                                            className="w-full text-left block text-white px-4 py-1.5 hover:bg-[#3f4448] dark:hover:text-white"
                                            onClick={() => handleLocationChange({
                                                id: item.id,
                                                name: item.name,
                                                code: item.code,
                                            })}
                                        >
                                            {item.name}
                                        </button>
                                    </li>
                                )
                            })}
                            {availableLocations.length === 0 &&
                                <li>
                                    <p
                                        className={`text-gray-300 px-4 py-1.5 text-left`}
                                        data-testid="location-picker-label"
                                        style={{fontSize: `${12 + accessibilityFont}px`}}
                                    >
                                        Nenhum local encontrado!
                                    </p>
                                </li>
                            }
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default LocationPicker;
